import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import BrowserHelper from 'src/app/helpers/browser-helper';
import IPBoard from 'src/app/model/product/ip-board/ip-board';
import { BaseProject } from 'src/app/model/project/base-project';
import { Project } from 'src/app/model/project/project';

@Component({
  selector: 'client-sub-project-design-collapse',
  templateUrl: './client-sub-project-design-collapse.component.html',
  styleUrls: ['./client-sub-project-design-collapse.component.scss'],
})
export class ClientSubProjectDesignCollapseComponent implements OnInit {
  @Input()
  project: Project;

  @Input()
  baseProject: BaseProject;

  @Input()
  ipBoard: IPBoard;

  @Input()
  designCollapsed: boolean = true;

  @Output()
  save = new EventEmitter();

  safari: boolean;

  designCollapsedInternal: boolean = false;

  constructor() {}

  ngOnInit(): void {
    this.safari = BrowserHelper.isSafari();
    this.designCollapsedInternal = this.designCollapsed;
  }
}
